import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a66528c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "pt-10"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg" }, "Add item to:", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-center pt-10" }, "- EXISTING PLAYLIST -", -1))
const _hoisted_4 = { class: "pb-12" }
const _hoisted_5 = { class: "wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-bold" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select a Playlist", -1))
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-red-600" }
const _hoisted_11 = { class: "pt-4" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-center pt-10" }, "- OR NEW PLAYLIST -", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_playlist_form = _resolveComponent("playlist-form")!

  return (_ctx.loading)
    ? (_openBlock(), _createBlock(_component_loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("form", _hoisted_4, [
          _createElementVNode("label", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.input.playlistId) = $event)),
              class: "field",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validate()))
            }, [
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlistOptions, (option) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: option.id,
                  key: option.title
                }, _toDisplayString(option.title), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.input.playlistId]
            ])
          ]),
          _createElementVNode("div", null, [
            (_ctx.createPlaylistItemErrors)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.createPlaylistItemErrors, (error) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: error[0]
                    }, [
                      _createElementVNode("p", _hoisted_10, _toDisplayString(error), 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn btn-primary float-left has-tooltip relative",
                disabled: _ctx.disabled,
                onClick: [
                  _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.callCreatePlaylistItem && _ctx.callCreatePlaylistItem(...args))),
                  _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.disabled && _ctx.disabled(...args)), ["prevent"]))
                ]
              }, " Add to Playlist ", 8, _hoisted_12)
            ])
          ])
        ]),
        _hoisted_13,
        _createVNode(_component_playlist_form, {
          user: _ctx.user,
          itemId: _ctx.id,
          itemType: _ctx.type,
          showForm: true,
          onCloseForm: _ctx.closeSidebar
        }, null, 8, ["user", "itemId", "itemType", "onCloseForm"])
      ]))
}